import React from 'react';

import {
  Panel,
  Flex,
  InfoSection,
  TabButton,
  Divider
} from '@sopranodesign/pulse-components';
import { ButtonComposer } from '@sopranodesign/pulse-composer';
import { AnimateSharedLayout } from '@sopranodesign/framer-motion';
import { useLanguages, LanguagesConsumer } from '@sopranodesign/pulse-hooks';

import { useBotSettings } from '../../hooks/index';

const ComposerSettings = () => {
  const {
    language,
    setLanguage,
    settings,
    focusBot,
    setSettings
  } = useBotSettings();
  const { languages } = useLanguages();

  const handleButtonChange = buttonsInCurrentLanguage => {
    focusBot();

    setSettings(settings => {
      const buttons = settings.buttons
        .filter(button => button.language_id !== language.id)
        .concat(
          buttonsInCurrentLanguage.map(button => ({
            ...button,
            language_id: language.id
          }))
        );

      return { ...settings, buttons };
    });
  };

  return (
    <Panel>
      <InfoSection
        mtNone
        title="Hamburger"
        info="Create a persistent menu."
      />
      <Divider />
        <Flex col ySpace>
          <LanguagesConsumer>
            <Flex>
              <AnimateSharedLayout>
                {languages.map(languageTab => (
                  <TabButton
                    onClick={() => setLanguage(languageTab)}
                    active={languageTab.id === language.id}
                    key={languageTab.id}>
                    {languageTab.name}
                  </TabButton>
                ))}
              </AnimateSharedLayout>
            </Flex>
            <Divider fullWidth mtNone />
          </LanguagesConsumer>
          <ButtonComposer
            only={['postback']}
            value={settings.buttons.filter(
              button => button.language_id === language.id
            )}
            onChange={handleButtonChange}
          />
        </Flex>
    </Panel>
  );
};

export default ComposerSettings;
